
import React from "react";
import cardavanti from "../../assets/cardavanti.png";
import { InfoAvantiCardContainer } from "./styles";
import { PLANS } from "../../utils/consts";

const InfoAvantiCard = (props) => {
    const { planName, userName, totalLuckyNumbers, isAvanti=false } = props;
   return (
      <InfoAvantiCardContainer>
        {!isAvanti ? (
          <>
            <div className="infoUserContainer">
            {PLANS[planName] && (
              <img className="img" src={PLANS[planName]} alt="userPlan" />
            )}
              <div className="infoUser">
                <span className="planName">{planName}</span>
                <span className="userName">{userName}</span>
              </div>
            </div>
            <div className="luckInfo">
              <span className="luckyText">Você já possui</span>
              <span className="totalLuckyNumbers">{totalLuckyNumbers}</span>
              <span className="luckyText"> números da sorte</span>
            </div>
            <div className="buttonMyNumbersContainer" onClick={() => {props.onChangeTab("Meus Números")}}>
              <div className="buttonMyNumbersText">Meus Números</div>
            </div>
          </>
        ) : (
          <div className="isAvantiContainer">
            <span className="avantiText">SEJA AVANTI para PARTICIpar DA PROMOÇÃO</span>
            <a href="https://ingressospalmeiras.com.br" target="_blank" className="buttonMyNumbersContainer" rel="noreferrer">
              <div className="buttonMyNumbersText">Seja Avanti</div>
            </a>
          </div>
        )}
      </InfoAvantiCardContainer>
    );
  }
  export default InfoAvantiCard;